export default __webpack_public_path__ + "static/8-1cd45205ebade0771562ec9dd91573f5.jpg";